import React from "react";
import Logs from "../images/firelogs.jpg"
import Crate from "../images/crate.jpg"
import Wood from "../images/processheader.jpg"

const Products = (props) => {

    return (
        <div>
            <h1>Our Products</h1>
            <img src={Wood} class="img-fluid mb-3" />
            <div class="row justify-content-center">
                <p>We offer Seasoned, Green, and Kiln Dried firewood. Our standard length is 16". However, we offer custom lengths from 12" to 21" for our green and kiln dried products. Our machine is typically operated with two splitters working simultaneously to ensure consistent split sizes, and to weed out any pieces that don't meet our quality standards.</p>
                <div class="card card-img m-4 ">
                    <img src={Logs} class="card-img-top" />
                    <div class="card-body">
                        <ul class="list-group list-group-flush">
                            <li class="list-group-item li-headline">Seasoned Firewood</li>
                            <li class="list-group-item li-text">Seasoned for at least 6 months in open air for low moisture and perfect burn. Tumbled before loading for less debris at delivery site.</li>
                            <li class="list-group-item">Price per Cord: $355</li>
                        </ul>
                        {/* <button type="button" class="btn btn-dark mt-3">Order now!</button> */}
                    </div>
                </div>

                <div class="card card-img m-4">
                    <img src={Crate} class="card-img-top" />
                    <div class="card-body">
                        <ul class="list-group list-group-flush">
                            <li class="list-group-item li-headline">Kiln-Dried Firewood</li>
                            <li class="list-group-item li-text">Heat-treated in large kiln for optimal moisture content, and excellent burn. The wood is bug-free and suitable for indoor storage. </li>
                            <li class="list-group-item">Price per Cord: $450</li>
                        </ul>
                        {/* <button type="button" class="btn btn-dark mt-3" value={props.value} onClick={(event) => { props.onChange(event.target.value) }}>Order now!</button> */}
                    </div>
                </div>
                <div class="card card-img m-4">
                    <img src={Crate} class="card-img-top" />
                    <div class="card-body">
                        <ul class="list-group list-group-flush">
                            <li class="list-group-item li-headline">Green Firewood</li>
                            <li class="list-group-item li-text">Freshly split wood for stacking and dryring. This firewood is not intended for immediate use due to high moisture content. </li>
                            <li class="list-group-item">Price per Cord: $270</li>
                        </ul>
                        {/* <button type="button" class="btn btn-dark mt-3" value={props.value} onClick={(event) => { props.onChange(event.target.value) }}>Order now!</button> */}
                    </div>
                </div>
            </div>
        </div>
    )
};
export default Products;